const initialState = {
    listaBeneficios: [],
    showBeneficiosText:''
};

export function beneficiosRdc(state = initialState, action) {
    switch (action.type) {
        case "BENEFICIOS_LLENAR":
        return {...state,
            listaBeneficios: action.beneficiosGnp,
            showBeneficiosText:action.showBeneficiosText
        };
        default:
		    return state;
    }
}


// WEBPACK FOOTER //
// ./src/Beneficios/reducer.js